import React, { useContext, useEffect } from "react";
import { Box, Grid2, Typography, Link, useMediaQuery } from "@mui/material";
import styles from "./LoginPage.module.scss";
import CustomButton from "../../components/v2/custom-button/CustomButton";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../auth/admin-auth/AdminAuthConfig";
import { useLocation, useNavigate } from "react-router-dom";
import { PATIENT_CONFIGS } from "../../utility/constants/common-constants";
import BackgroundLayout from "../../components/custom-backgrounds/BackgroundLayout";
import { useTranslation } from "react-i18next";
import appLogoText from "../../../src/assets/images/app-logo/app_logo_text.png";
import appBunnyLogo from "../../../src/assets/images/app-logo/app_bunny_logo.png";
import { FhirAuthContext } from "../../auth/patient-auth/FhirAuthProvider";

const LoginPage: React.FC = () => {
  const isMobile = useMediaQuery("(max-width: 900px)");
  const height = {
    xs: "15.38rem",
    sm: "16.88rem",
    md: "16.31rem",
  };
  const { i18n, t } = useTranslation();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();

  const { tokenResponse } = useContext(FhirAuthContext);

  const patientPreferredLang = localStorage.getItem("patientPreferredLang");

  useEffect(() => {
    if (tokenResponse) {
      console.log("Token response received, redirecting to /patient...");
      navigate("/patient", { replace: true });
    }

    if (patientPreferredLang) {
      i18n.changeLanguage(patientPreferredLang);
    }
  }, [tokenResponse, navigate, i18n, patientPreferredLang]);

  const handleAdminLogin = () => {
    if (!location.pathname.includes("/admin")) {
      navigate("/admin");
    }
    instance
      .loginRedirect(loginRequest)
      .then((response) => {})
      .catch((error) => {
        console.error("Login failed:", error);
      });
  };

  const handlePatientLogin = () => {
    window.location.href = PATIENT_CONFIGS.MYCHART_LOGIN_REDIRECT_URL || "";
  };

  return (
    <BackgroundLayout
      variant={isMobile ? "welcomeOverviewMobile" : "welcomeOverviewDesktop"}
      height={height}
    >
      <Grid2
        container
        sx={{
          width: "100%",
          height: "60vh",
          paddingTop: "10px",
          verticalAlign: "center",
        }}
      >
        <Grid2
          size={{ xs: 12, sm: 12, md: 12 }}
          className={styles.greenSection}
        >
          <Box className={`${styles.welcomeContainer}`}>
            <Typography variant="bodySmall">
              <Box className={`${styles.welcomeText}`}>
                {" "}
                {t("welcomeToLena")}{" "}
              </Box>
              <Box className={`${styles.welcomeDetails}`}>
                {" "}
                {t("yourPregJourneyLogin")}{" "}
              </Box>
            </Typography>
            <img
              src={appBunnyLogo}
              alt="App Logo"
              width="150px"
              height="250px"
            />
          </Box>
          <img src={appLogoText} alt="App Logo" width="222px" height="125px" />
          <Box className={styles.buttonGroup}>
            <CustomButton
              variant="contained"
              onClick={handlePatientLogin}
              text={t("login")}
              className={styles.loginButton}
            />
            <CustomButton
              variant="text"
              className={styles.adminButton}
              onClick={handleAdminLogin}
              text={t("adminLogin")}
              component={Link}
              color="secondary"
            />
          </Box>
        </Grid2>
      </Grid2>
    </BackgroundLayout>
  );
};

export default LoginPage;
